module.exports = __webpack_public_path__ + "static/media/geraldo.41c58f7d.jpg";